(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reasons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('reasons-accordion')) return;

    class ReasonsAccordion extends HTMLElement {
      constructor() {
        super();
        this.onToggle = this.onToggle.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        // Capture is needed because native details toggle events do not bubble.
        this.addEventListener('toggle', this.onToggle, true);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.onToggle, true);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      closeOthers(currentItem) {
        if (this.dataset.singleOpen !== 'true') return;
        this.querySelectorAll('details.reasons__item[open]').forEach((item) => {
          if (item !== currentItem) item.open = false;
        });
      }

      onToggle(event) {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.open) return;
        if (item.closest('reasons-accordion') !== this) return;
        // Fallback for browsers without native details name-group support.
        this.closeOthers(item);
      }

      onBlockSelect(event) {
        if (!(event.target instanceof Element)) return;
        const item = event.target.closest('details.reasons__item');
        if (!item || item.closest('reasons-accordion') !== this) return;
        this.closeOthers(item);
        item.open = true;
      }
    }

    customElements.define('reasons-accordion', ReasonsAccordion);
  })();

  } catch(e) { console.error(e); }
})();
})();
